import React from 'react'
import Nav from './nav'
import styled from 'styled-components'




function Header() {
    return (
    <header>
        <Nav />
    </header>
    )
}

export default Header